import { render, staticRenderFns } from "./ReviewDetailsPage.vue?vue&type=template&id=8f5fc78e&"
import script from "./ReviewDetailsPage.vue?vue&type=script&lang=js&"
export * from "./ReviewDetailsPage.vue?vue&type=script&lang=js&"
import style0 from "./ReviewDetailsPage.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports